<template>
  <div>
    <h2 class="mt-10">API-ключ</h2>
    <v-row>
      <v-col class="apikey" cols="6">
        <v-progress-circular
          v-if="loading"
          class="ml-1"
          indeterminate
          size="32"
        ></v-progress-circular>
        <v-text-field
          v-else
          label="API-ключ"
          placeholder="90"
          filled
          v-model="apikey"
          readonly
          ref="apikey"
          id="apikey"
        ></v-text-field>
      </v-col>
      <v-col cols="6" class="d-flex justify-space-around">
        <v-btn color="default" @click="copy"
          ><v-icon>mdi-content-copy</v-icon> Копировать</v-btn
        >
        <v-btn color="default" @click="refresh"
          ><v-icon>mdi-refresh</v-icon> Пересоздать</v-btn
        >
        <v-btn color="default" @click="$router.push(`/demo/${apikey}`)"
          ><v-icon>mdi-map-search-outline</v-icon> Карта</v-btn
        >
      </v-col>
    </v-row>
    <h2 class="mt-10">Код виджета</h2>
    <v-row>
      <v-col>
        <v-select v-model="template" :items="templates" label="Шаблон виджета"/>
        <v-textarea id="widget" filled :value="widget"></v-textarea>
      </v-col>
      <v-col>
        <v-btn color="default" @click="copyWidget"
          ><v-icon>mdi-content-copy</v-icon> Копировать</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from "../api";
import store from "../store";
import axios from "axios";

export default {
  name: "api-key",
  props: ["token", "id"],
  data() {
    return {
      apikey: this.token,
      loading: false,
      template: "",
      templates: [
        { text: "По-умолчанию", value: "" },
        { text: "Все инструменты", value: "ai" }
      ]
    };
  },
  computed: {
    tpl() {
      return this.template ? `&tpl=${this.template}` : '';
    },
    widget() {
      return `<iframe width="100%" height="700" style="border:0;" sandbox="allow-scripts allow-same-origin allow-top-navigation" src="${api.url}/widget?token=${this.token}${this.tpl}"/>`;
    }
  },
  methods: {
    copy() {
      let copyText = document.getElementById("apikey");

      /* Select the text field */
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      document.execCommand("copy");

      store.snackbar = true;
      store.snackbarSuccess = true;
      store.snackbarMessage = "API-Ключ скопирован";
    },
    copyWidget() {
      let copyText = document.getElementById("widget");

      /* Select the text field */
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      document.execCommand("copy");

      store.snackbar = true;
      store.snackbarSuccess = true;
      store.snackbarMessage = "Код виджета скопирован";
    },
    refresh() {
      this.loading = true;
      axios
        .get(api.token(this.id))
        .then(resp => {
          this.apikey = resp.data.token;
          store.snackbar = true;
          store.snackbarSuccess = true;
          store.snackbarMessage = "API-Ключ создан";
        })
        .catch(err => {
          store.snackbar = true;
          store.snackbarSuccess = false;
          store.snackbarMessage = err.message;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style></style>
